import {Injectable} from '@angular/core';
import {CookieService, CookieOptions} from 'ngx-cookie';
import { UserProfileModel } from "./views/account/profile/userprofile.model";

export type InternalStateType = {
    [key: string]: any
};

@Injectable()
export class AppState {
    constructor(private _cookieService: CookieService) {
    }

    public _state: InternalStateType = {};

    public authToken: string;

    public getCookie(key: string): string {
        return this._cookieService.get(key);
    }

    public isLoggedIn(): boolean {
        var cookieVal: string = this._cookieService.get("authToken");
        return  cookieVal != "" && cookieVal !== undefined;
    }

    public CurrentUser(): UserProfileModel {
        var cookieVal: string = this._cookieService.get("userIdentity"); 

        return UserProfileModel.fromJson(JSON.parse(cookieVal));
    }

    public setCookie(key: string, value: string, options?: CookieOptions): void {
        var now = Date.now();
        var expires = new Date(now + 24 * 60 * 60 * 1000);
        if (process.env.ENV == 'production') {
            expires = new Date(now + 2 * 60 * 60 * 1000);
        }
        if (options === undefined) {
            options = {expires: expires};
        }
        options.expires = expires;
        this._cookieService.put(key, value, options);
    }

    public removeAllCookies(): void {
        this._cookieService.removeAll();
    }

    /**
     * Already return a clone of the current state.
     */
    public get state() {
        return this._state = this._clone(this._state);
    }

    /**
     * Never allow mutation
     */
    public set state(value) {
        throw new Error('do not mutate the `.state` directly');
    }

    public get(prop?: any) {
        /**
         * Use our state getter for the clone.
         */
        const state = this.state;
        return state.hasOwnProperty(prop) ? state[prop] : state;
    }

    public set(prop: string, value: any) {
        /**
         * Internally mutate our state.
         */
        return this._state[prop] = value;
    }

    private _clone(object: InternalStateType) {
        /**
         * Simple object clone.
         */
        return JSON.parse(JSON.stringify(object));
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.service.ts